import { FunctionComponent } from "react";
import { useTenantsByCrmIdQuery } from "@libs/api/gateways/plt/plt-gateway.hooks";
import { useMatch, useNavigate } from "react-router-dom";
import { CenteredLargeSpinner } from "@bps/fluent-ui";
import { externalRedirectRoutes } from "../../../libs/routing/routing.constants";
import { useFeedbackContext } from "../../../libs/stores/feedback-context/feedback-context";

export const CrmRedirect: FunctionComponent = () => {
  const match = useMatch(externalRedirectRoutes.crmId);
  const { error } = useFeedbackContext();
  const navigate = useNavigate();

  if (!match?.params?.crmId) {
    navigate("../../tenants");
  }

  const { isLoading } = useTenantsByCrmIdQuery(match?.params.crmId!, {
    enabled: !!match?.params?.crmId,
    onError: err => {
      error(err?.message);
      navigate("../../tenants/");
    },
    onSuccess: data => {
      if (data.length === 0) {
        navigate("../../tenants/");
      } else if (data.length === 1) {
        navigate(`../../tenants/${data[0].id}/plt-details`);
      } else {
        // multiple tenants found
        navigate(`../../tenants?crmId=${match?.params.crmId}/`);
      }
    }
  });

  if (isLoading) {
    return (
      <CenteredLargeSpinner
        label="Proccesing redirect ..."
        labelPosition="bottom"
      />
    );
  }
  return null;
};
